import {
  GET_COLECCION_DOCUMENTOS_PROYECTO,
  UPDATE_DOCUMENTOS_PROYECTO
} from '../../shared/constants/ActionTypes';

const initialState = {
  rows: [],
  ligera: [],
  selectedRow: null,
  desde: 1,
  hasta: 1,
  por_pagina: 1,
  pagina_actual: 1,
  ultima_pagina: 1,
  total: 1,
};

const DocumentosProyectoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COLECCION_DOCUMENTOS_PROYECTO:
      return {
        ...state,
        rows: action.payload.data.datos,
        desde: action.payload.data.desde,
        hasta: action.payload.data.hasta,
        por_pagina: action.payload.data.por_pagina,
        pagina_actual: action.payload.data.pagina_actual,
        ultima_pagina: action.payload.data.ultima_pagina,
        total: action.payload.data.total,
      };
    case UPDATE_DOCUMENTOS_PROYECTO:
      return {
        ...state,
        selectedRow: action.payload.datos,
      };

    default:
      return state;
  }
};
export default DocumentosProyectoReducer;
